/**
 * Created by henian.xu on 2017/11/7.
 *
 */

import VueRouter from 'vue-router';
import Routes from './routes';
import Navigator from './navigator';
import NavComponent from './components';
import { genKey, isObjEqual, isDef } from './utils';
import Nprogress from 'nprogress';

const { NavigationFailureType } = VueRouter;

export default {
  install(
    Vue,
    { router, store, moduleName = 'navigation', keyName = 'VNK' } = {},
  ) {
    if (!router) {
      throw new Error('navigation components need options: router');
    }

    const bus = new Vue();
    const navigator = Navigator(bus, store, moduleName, keyName);

    // hack vue-router replace for replaceFlag
    const oldRouteReplace = router.replace.bind(router);
    let replaceFlag = false;
    // eslint-disable-next-line no-param-reassign
    router.replace = (location, onComplete, onAbort) => {
      replaceFlag = true;
      if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
        return new Promise((resolve, reject) => {
          oldRouteReplace(location, resolve, err => {
            if (
              isDef(err) &&
              err.type !== NavigationFailureType.redirected &&
              err.type !== NavigationFailureType.cancelled
            ) {
              reject(err);
            } else {
              setTimeout(() => {
                // 为了解决在 beforeEach,beforeResolve 中调用
                // router.replace 方法时 router.afterEach 没有触的问题
                replaceFlag = false;
              }, 500);
              resolve();
            }
          });
        });
      }
      return oldRouteReplace(location, onComplete, onAbort);
    };
    // hack vue-router push 为了解决 在路径上加 keyName 参数时 Promise 为 reject
    const oldRoutePush = router.push.bind(router);
    // eslint-disable-next-line no-param-reassign
    router.push = (location, onComplete, onAbort) => {
      if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
        return new Promise((resolve, reject) => {
          oldRoutePush(location, resolve, err => {
            if (
              isDef(err) &&
              err.type !== NavigationFailureType.redirected &&
              err.type !== NavigationFailureType.cancelled
            ) {
              reject(err);
            } else {
              resolve();
            }
          });
        });
      }
      return oldRoutePush(location, onComplete, onAbort);
    };

    // 为url 加上key
    router.beforeEach((to, from, next) => {
      if (!to.query[keyName]) {
        const query = { ...to.query };
        // go to the same route will be set the same key
        if (
          to.path === from.path &&
          isObjEqual(
            { ...to.query, [keyName]: null },
            { ...from.query, [keyName]: null },
          ) &&
          from.query[keyName]
        ) {
          query[keyName] = from.query[keyName];
        } else {
          query[keyName] = genKey();
        }
        // debugger;
        next({
          path: to.path,
          query,
          replace: replaceFlag || !from.query[keyName],
        });
      } else {
        // debugger;
        if (!Nprogress.timeId) {
          Nprogress.timeId = setTimeout(() => {
            Nprogress.start();
          }, 1000);
        }
        next();
      }
    });

    // record router change
    router.afterEach((to, from) => {
      navigator.record(to, from, replaceFlag);
      replaceFlag = false;
      if (Nprogress.timeId) {
        clearTimeout(Nprogress.timeId);
        Nprogress.timeId = 0;
        Nprogress.done();
      }
    });

    Vue.component('navigation', NavComponent(keyName));
    Vue.navigation = Vue.prototype.$navigation = {
      on: (event, callback) => {
        bus.$on(event, callback);
      },
      once: (event, callback) => {
        bus.$once(event, callback);
      },
      off: (event, callback) => {
        bus.$off(event, callback);
      },
      getRoutes() {
        return Routes.slice();
      },
      cleanRoutes() {
        navigator.reset();
      },
    };
  },
};
